import { nodeViewProps as ft, NodeViewWrapper as pt, VueRenderer as je, VueNodeViewRenderer as mt, EditorContent as ze, Editor as Fe } from "../../node_modules/@tiptap/vue-3.js";
import { isTextSelection as Ke, posToDOMRect as re, getText as We, getTextSerializersFromSchema as qe, Node as ae, nodePasteRule as Et, InputRule as Xe, mergeAttributes as st, getMarksBetween as Ye, combineTransactionSteps as Ge, getChangedRanges as Je, findChildrenInRange as Ze, Mark as Qe, nodeInputRule as tn, Extension as en } from "@tiptap/core";
import { Plugin as It, PluginKey as rt, NodeSelection as nn } from "@tiptap/pm/state";
import { CellSelection as on } from "@tiptap/pm/tables";
import { defineComponent as le, ref as ce, onMounted as de, nextTick as sn, onBeforeUnmount as ue, h as he, resolveComponent as T, openBlock as k, createBlock as M, withCtx as C, createVNode as I, createElementBlock as et, withDirectives as rn, createElementVNode as nt, Fragment as an, renderList as ln, withModifiers as Dt, normalizeClass as fe, resolveDynamicComponent as cn, vShow as dn, markRaw as un, createTextVNode as at, toDisplayString as $, createCommentVNode as it, withKeys as hn, mergeProps as pe } from "vue";
import fn from "@tiptap/extension-blockquote";
import pn from "@tiptap/extension-code-block";
import mn from "@tiptap/extension-code";
import gn from "@tiptap/extension-document";
import { UndoRedo as yn, Placeholder as wn, Gapcursor as bn } from "@tiptap/extensions";
import vn from "@tiptap/extension-hard-break";
import me from "@tiptap/extension-paragraph";
import xn from "@tiptap/extension-bold";
import { BulletList as Tn, ListItem as _n, OrderedList as kn } from "@tiptap/extension-list";
import Cn from "@tiptap/extension-italic";
import On from "@tiptap/extension-link";
import En from "@tiptap/extension-strike";
import Sn from "@tiptap/extension-underline";
import Ln from "@tiptap/extension-text";
import In from "@tiptap/extension-text-align";
import { Table as Dn, TableRow as An, TableHeader as Rn, TableCell as Mn } from "@tiptap/extension-table";
import { TextStyleKit as Hn } from "@tiptap/extension-text-style";
import $n from "@tiptap/suggestion";
import { emojiPattern as ge } from "regex-combined-emojis";
import { _ as q } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import ye from "../emoji/emoji.js";
import { getEmojiData as Bn, emojiRegex as Nn, stringToUnicode as Pn, codeToEmojiData as At, emojiShortCodeRegex as Un } from "../../common/emoji/index.js";
import Vn from "../list-item/list-item.js";
import gt from "../stack/stack.js";
import { linkRegex as jn, getPhoneNumberRegex as zn, warnIfUnmounted as Fn, returnFirstEl as zt } from "../../common/utils/index.js";
import Kn from "@tiptap/extension-image";
import Rt from "@tiptap/extension-mention";
import we from "../link/link.js";
import { DtIconLock as Wn } from "@dialpad/dialtone-icons/vue3";
import { DialtoneLocalization as be } from "../../localization/index.js";
import qn from "../input/input.js";
import Xn from "../popover/popover.js";
import ve from "../button/button.js";
import Yn from "../badge/badge.js";
import { RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS as Ft, RICH_TEXT_EDITOR_OUTPUT_FORMATS as Gn, RICH_TEXT_EDITOR_AUTOFOCUS_TYPES as Jn } from "./rich-text-editor-constants.js";
import Zn from "../avatar/avatar.js";
import Qn from "@dialpad/dialtone-icons/vue3/hash";
import to from "@dialpad/dialtone-icons/vue3/lock";
import eo from "deep-equal";
const xe = ["top", "right", "bottom", "left"], Kt = ["start", "end"], Wt = /* @__PURE__ */ xe.reduce((t, e) => t.concat(e, e + "-" + Kt[0], e + "-" + Kt[1]), []), G = Math.min, R = Math.max, wt = Math.round, Y = (t) => ({
  x: t,
  y: t
}), no = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oo = {
  start: "end",
  end: "start"
};
function St(t, e, o) {
  return R(t, G(e, o));
}
function Z(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function j(t) {
  return t.split("-")[0];
}
function F(t) {
  return t.split("-")[1];
}
function Te(t) {
  return t === "x" ? "y" : "x";
}
function Mt(t) {
  return t === "y" ? "height" : "width";
}
const io = /* @__PURE__ */ new Set(["top", "bottom"]);
function X(t) {
  return io.has(j(t)) ? "y" : "x";
}
function Ht(t) {
  return Te(X(t));
}
function _e(t, e, o) {
  o === void 0 && (o = !1);
  const n = F(t), i = Ht(t), s = Mt(i);
  let r = i === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (r = vt(r)), [r, vt(r)];
}
function so(t) {
  const e = vt(t);
  return [bt(t), e, bt(e)];
}
function bt(t) {
  return t.replace(/start|end/g, (e) => oo[e]);
}
const qt = ["left", "right"], Xt = ["right", "left"], ro = ["top", "bottom"], ao = ["bottom", "top"];
function lo(t, e, o) {
  switch (t) {
    case "top":
    case "bottom":
      return o ? e ? Xt : qt : e ? qt : Xt;
    case "left":
    case "right":
      return e ? ro : ao;
    default:
      return [];
  }
}
function co(t, e, o, n) {
  const i = F(t);
  let s = lo(j(t), o === "start", n);
  return i && (s = s.map((r) => r + "-" + i), e && (s = s.concat(s.map(bt)))), s;
}
function vt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => no[e]);
}
function uo(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function $t(t) {
  return typeof t != "number" ? uo(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ct(t) {
  const {
    x: e,
    y: o,
    width: n,
    height: i
  } = t;
  return {
    width: n,
    height: i,
    top: o,
    left: e,
    right: e + n,
    bottom: o + i,
    x: e,
    y: o
  };
}
function Yt(t, e, o) {
  let {
    reference: n,
    floating: i
  } = t;
  const s = X(e), r = Ht(e), a = Mt(r), l = j(e), u = s === "y", d = n.x + n.width / 2 - i.width / 2, c = n.y + n.height / 2 - i.height / 2, h = n[a] / 2 - i[a] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: d,
        y: n.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: c
      };
      break;
    case "left":
      f = {
        x: n.x - i.width,
        y: c
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (F(e)) {
    case "start":
      f[r] -= h * (o && u ? -1 : 1);
      break;
    case "end":
      f[r] += h * (o && u ? -1 : 1);
      break;
  }
  return f;
}
async function ho(t, e) {
  var o;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: s,
    rects: r,
    elements: a,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: c = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = Z(e, t), p = $t(f), g = a[h ? c === "floating" ? "reference" : "floating" : c], y = ct(await s.getClippingRect({
    element: (o = await (s.isElement == null ? void 0 : s.isElement(g))) == null || o ? g : g.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), b = c === "floating" ? {
    x: n,
    y: i,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, v = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), x = await (s.isElement == null ? void 0 : s.isElement(v)) ? await (s.getScale == null ? void 0 : s.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = ct(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: b,
    offsetParent: v,
    strategy: l
  }) : b);
  return {
    top: (y.top - O.top + p.top) / x.y,
    bottom: (O.bottom - y.bottom + p.bottom) / x.y,
    left: (y.left - O.left + p.left) / x.x,
    right: (O.right - y.right + p.right) / x.x
  };
}
const fo = async (t, e, o) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: r
  } = o, a = s.filter(Boolean), l = await (r.isRTL == null ? void 0 : r.isRTL(e));
  let u = await r.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: d,
    y: c
  } = Yt(u, n, l), h = n, f = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    var m;
    const {
      name: y,
      fn: b
    } = a[g], {
      x: v,
      y: x,
      data: O,
      reset: _
    } = await b({
      x: d,
      y: c,
      initialPlacement: n,
      placement: h,
      strategy: i,
      middlewareData: f,
      rects: u,
      platform: {
        ...r,
        detectOverflow: (m = r.detectOverflow) != null ? m : ho
      },
      elements: {
        reference: t,
        floating: e
      }
    });
    d = v ?? d, c = x ?? c, f = {
      ...f,
      [y]: {
        ...f[y],
        ...O
      }
    }, _ && p <= 50 && (p++, typeof _ == "object" && (_.placement && (h = _.placement), _.rects && (u = _.rects === !0 ? await r.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : _.rects), {
      x: d,
      y: c
    } = Yt(u, h, l)), g = -1);
  }
  return {
    x: d,
    y: c,
    placement: h,
    strategy: i,
    middlewareData: f
  };
}, po = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: o,
      y: n,
      placement: i,
      rects: s,
      platform: r,
      elements: a,
      middlewareData: l
    } = e, {
      element: u,
      padding: d = 0
    } = Z(t, e) || {};
    if (u == null)
      return {};
    const c = $t(d), h = {
      x: o,
      y: n
    }, f = Ht(i), p = Mt(f), m = await r.getDimensions(u), g = f === "y", y = g ? "top" : "left", b = g ? "bottom" : "right", v = g ? "clientHeight" : "clientWidth", x = s.reference[p] + s.reference[f] - h[f] - s.floating[p], O = h[f] - s.reference[f], _ = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(u));
    let L = _ ? _[v] : 0;
    (!L || !await (r.isElement == null ? void 0 : r.isElement(_))) && (L = a.floating[v] || s.floating[p]);
    const U = x / 2 - O / 2, D = L / 2 - m[p] / 2 - 1, w = G(c[y], D), E = G(c[b], D), A = w, H = L - m[p] - E, S = L / 2 - m[p] / 2 + U, z = St(A, S, H), V = !l.arrow && F(i) != null && S !== z && s.reference[p] / 2 - (S < A ? w : E) - m[p] / 2 < 0, B = V ? S < A ? S - A : S - H : 0;
    return {
      [f]: h[f] + B,
      data: {
        [f]: z,
        centerOffset: S - z - B,
        ...V && {
          alignmentOffset: B
        }
      },
      reset: V
    };
  }
});
function mo(t, e, o) {
  return (t ? [...o.filter((i) => F(i) === t), ...o.filter((i) => F(i) !== t)] : o.filter((i) => j(i) === i)).filter((i) => t ? F(i) === t || (e ? bt(i) !== i : !1) : !0);
}
const go = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var o, n, i;
      const {
        rects: s,
        middlewareData: r,
        placement: a,
        platform: l,
        elements: u
      } = e, {
        crossAxis: d = !1,
        alignment: c,
        allowedPlacements: h = Wt,
        autoAlignment: f = !0,
        ...p
      } = Z(t, e), m = c !== void 0 || h === Wt ? mo(c || null, f, h) : h, g = await l.detectOverflow(e, p), y = ((o = r.autoPlacement) == null ? void 0 : o.index) || 0, b = m[y];
      if (b == null)
        return {};
      const v = _e(b, s, await (l.isRTL == null ? void 0 : l.isRTL(u.floating)));
      if (a !== b)
        return {
          reset: {
            placement: m[0]
          }
        };
      const x = [g[j(b)], g[v[0]], g[v[1]]], O = [...((n = r.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: b,
        overflows: x
      }], _ = m[y + 1];
      if (_)
        return {
          data: {
            index: y + 1,
            overflows: O
          },
          reset: {
            placement: _
          }
        };
      const L = O.map((w) => {
        const E = F(w.placement);
        return [w.placement, E && d ? (
          // Check along the mainAxis and main crossAxis side.
          w.overflows.slice(0, 2).reduce((A, H) => A + H, 0)
        ) : (
          // Check only the mainAxis.
          w.overflows[0]
        ), w.overflows];
      }).sort((w, E) => w[1] - E[1]), D = ((i = L.filter((w) => w[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        F(w[0]) ? 2 : 3
      ).every((E) => E <= 0))[0]) == null ? void 0 : i[0]) || L[0][0];
      return D !== a ? {
        data: {
          index: y + 1,
          overflows: O
        },
        reset: {
          placement: D
        }
      } : {};
    }
  };
}, yo = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var o, n;
      const {
        placement: i,
        middlewareData: s,
        rects: r,
        initialPlacement: a,
        platform: l,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: c = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...g
      } = Z(t, e);
      if ((o = s.arrow) != null && o.alignmentOffset)
        return {};
      const y = j(i), b = X(a), v = j(a) === a, x = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), O = h || (v || !m ? [vt(a)] : so(a)), _ = p !== "none";
      !h && _ && O.push(...co(a, m, p, x));
      const L = [a, ...O], U = await l.detectOverflow(e, g), D = [];
      let w = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (d && D.push(U[y]), c) {
        const S = _e(i, r, x);
        D.push(U[S[0]], U[S[1]]);
      }
      if (w = [...w, {
        placement: i,
        overflows: D
      }], !D.every((S) => S <= 0)) {
        var E, A;
        const S = (((E = s.flip) == null ? void 0 : E.index) || 0) + 1, z = L[S];
        if (z && (!(c === "alignment" ? b !== X(z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        w.every((N) => X(N.placement) === b ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: S,
              overflows: w
            },
            reset: {
              placement: z
            }
          };
        let V = (A = w.filter((B) => B.overflows[0] <= 0).sort((B, N) => B.overflows[1] - N.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!V)
          switch (f) {
            case "bestFit": {
              var H;
              const B = (H = w.filter((N) => {
                if (_) {
                  const tt = X(N.placement);
                  return tt === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  tt === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((tt) => tt > 0).reduce((tt, Ve) => tt + Ve, 0)]).sort((N, tt) => N[1] - tt[1])[0]) == null ? void 0 : H[0];
              B && (V = B);
              break;
            }
            case "initialPlacement":
              V = a;
              break;
          }
        if (i !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function Gt(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Jt(t) {
  return xe.some((e) => t[e] >= 0);
}
const wo = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: o,
        platform: n
      } = e, {
        strategy: i = "referenceHidden",
        ...s
      } = Z(t, e);
      switch (i) {
        case "referenceHidden": {
          const r = await n.detectOverflow(e, {
            ...s,
            elementContext: "reference"
          }), a = Gt(r, o.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Jt(a)
            }
          };
        }
        case "escaped": {
          const r = await n.detectOverflow(e, {
            ...s,
            altBoundary: !0
          }), a = Gt(r, o.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Jt(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function ke(t) {
  const e = G(...t.map((s) => s.left)), o = G(...t.map((s) => s.top)), n = R(...t.map((s) => s.right)), i = R(...t.map((s) => s.bottom));
  return {
    x: e,
    y: o,
    width: n - e,
    height: i - o
  };
}
function bo(t) {
  const e = t.slice().sort((i, s) => i.y - s.y), o = [];
  let n = null;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    !n || s.y - n.y > n.height / 2 ? o.push([s]) : o[o.length - 1].push(s), n = s;
  }
  return o.map((i) => ct(ke(i)));
}
const vo = function(t) {
  return t === void 0 && (t = {}), {
    name: "inline",
    options: t,
    async fn(e) {
      const {
        placement: o,
        elements: n,
        rects: i,
        platform: s,
        strategy: r
      } = e, {
        padding: a = 2,
        x: l,
        y: u
      } = Z(t, e), d = Array.from(await (s.getClientRects == null ? void 0 : s.getClientRects(n.reference)) || []), c = bo(d), h = ct(ke(d)), f = $t(a);
      function p() {
        if (c.length === 2 && c[0].left > c[1].right && l != null && u != null)
          return c.find((g) => l > g.left - f.left && l < g.right + f.right && u > g.top - f.top && u < g.bottom + f.bottom) || h;
        if (c.length >= 2) {
          if (X(o) === "y") {
            const w = c[0], E = c[c.length - 1], A = j(o) === "top", H = w.top, S = E.bottom, z = A ? w.left : E.left, V = A ? w.right : E.right, B = V - z, N = S - H;
            return {
              top: H,
              bottom: S,
              left: z,
              right: V,
              width: B,
              height: N,
              x: z,
              y: H
            };
          }
          const g = j(o) === "left", y = R(...c.map((w) => w.right)), b = G(...c.map((w) => w.left)), v = c.filter((w) => g ? w.left === b : w.right === y), x = v[0].top, O = v[v.length - 1].bottom, _ = b, L = y, U = L - _, D = O - x;
          return {
            top: x,
            bottom: O,
            left: _,
            right: L,
            width: U,
            height: D,
            x: _,
            y: x
          };
        }
        return h;
      }
      const m = await s.getElementRects({
        reference: {
          getBoundingClientRect: p
        },
        floating: n.floating,
        strategy: r
      });
      return i.reference.x !== m.reference.x || i.reference.y !== m.reference.y || i.reference.width !== m.reference.width || i.reference.height !== m.reference.height ? {
        reset: {
          rects: m
        }
      } : {};
    }
  };
}, xo = /* @__PURE__ */ new Set(["left", "top"]);
async function To(t, e) {
  const {
    placement: o,
    platform: n,
    elements: i
  } = t, s = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), r = j(o), a = F(o), l = X(o) === "y", u = xo.has(r) ? -1 : 1, d = s && l ? -1 : 1, c = Z(e, t);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: p
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return a && typeof p == "number" && (f = a === "end" ? p * -1 : p), l ? {
    x: f * d,
    y: h * u
  } : {
    x: h * u,
    y: f * d
  };
}
const _o = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var o, n;
      const {
        x: i,
        y: s,
        placement: r,
        middlewareData: a
      } = e, l = await To(e, t);
      return r === ((o = a.offset) == null ? void 0 : o.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: r
        }
      };
    }
  };
}, ko = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: o,
        y: n,
        placement: i,
        platform: s
      } = e, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x: b,
              y: v
            } = y;
            return {
              x: b,
              y: v
            };
          }
        },
        ...u
      } = Z(t, e), d = {
        x: o,
        y: n
      }, c = await s.detectOverflow(e, u), h = X(j(i)), f = Te(h);
      let p = d[f], m = d[h];
      if (r) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", v = p + c[y], x = p - c[b];
        p = St(v, p, x);
      }
      if (a) {
        const y = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", v = m + c[y], x = m - c[b];
        m = St(v, m, x);
      }
      const g = l.fn({
        ...e,
        [f]: p,
        [h]: m
      });
      return {
        ...g,
        data: {
          x: g.x - o,
          y: g.y - n,
          enabled: {
            [f]: r,
            [h]: a
          }
        }
      };
    }
  };
}, Co = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var o, n;
      const {
        placement: i,
        rects: s,
        platform: r,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...u
      } = Z(t, e), d = await r.detectOverflow(e, u), c = j(i), h = F(i), f = X(i) === "y", {
        width: p,
        height: m
      } = s.floating;
      let g, y;
      c === "top" || c === "bottom" ? (g = c, y = h === (await (r.isRTL == null ? void 0 : r.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = c, g = h === "end" ? "top" : "bottom");
      const b = m - d.top - d.bottom, v = p - d.left - d.right, x = G(m - d[g], b), O = G(p - d[y], v), _ = !e.middlewareData.shift;
      let L = x, U = O;
      if ((o = e.middlewareData.shift) != null && o.enabled.x && (U = v), (n = e.middlewareData.shift) != null && n.enabled.y && (L = b), _ && !h) {
        const w = R(d.left, 0), E = R(d.right, 0), A = R(d.top, 0), H = R(d.bottom, 0);
        f ? U = p - 2 * (w !== 0 || E !== 0 ? w + E : R(d.left, d.right)) : L = m - 2 * (A !== 0 || H !== 0 ? A + H : R(d.top, d.bottom));
      }
      await l({
        ...e,
        availableWidth: U,
        availableHeight: L
      });
      const D = await r.getDimensions(a.floating);
      return p !== D.width || m !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function xt() {
  return typeof window < "u";
}
function ut(t) {
  return Ce(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function P(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Q(t) {
  var e;
  return (e = (Ce(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ce(t) {
  return xt() ? t instanceof Node || t instanceof P(t).Node : !1;
}
function K(t) {
  return xt() ? t instanceof Element || t instanceof P(t).Element : !1;
}
function J(t) {
  return xt() ? t instanceof HTMLElement || t instanceof P(t).HTMLElement : !1;
}
function Zt(t) {
  return !xt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof P(t).ShadowRoot;
}
const Oo = /* @__PURE__ */ new Set(["inline", "contents"]);
function yt(t) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: n,
    display: i
  } = W(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !Oo.has(i);
}
const Eo = /* @__PURE__ */ new Set(["table", "td", "th"]);
function So(t) {
  return Eo.has(ut(t));
}
const Lo = [":popover-open", ":modal"];
function Tt(t) {
  return Lo.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Io = ["transform", "translate", "scale", "rotate", "perspective"], Do = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Ao = ["paint", "layout", "strict", "content"];
function Bt(t) {
  const e = Nt(), o = K(t) ? W(t) : t;
  return Io.some((n) => o[n] ? o[n] !== "none" : !1) || (o.containerType ? o.containerType !== "normal" : !1) || !e && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !e && (o.filter ? o.filter !== "none" : !1) || Do.some((n) => (o.willChange || "").includes(n)) || Ao.some((n) => (o.contain || "").includes(n));
}
function Ro(t) {
  let e = ot(t);
  for (; J(e) && !dt(e); ) {
    if (Bt(e))
      return e;
    if (Tt(e))
      return null;
    e = ot(e);
  }
  return null;
}
function Nt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Mo = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function dt(t) {
  return Mo.has(ut(t));
}
function W(t) {
  return P(t).getComputedStyle(t);
}
function _t(t) {
  return K(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ot(t) {
  if (ut(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Zt(t) && t.host || // Fallback.
    Q(t)
  );
  return Zt(e) ? e.host : e;
}
function Oe(t) {
  const e = ot(t);
  return dt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : J(e) && yt(e) ? e : Oe(e);
}
function Ee(t, e, o) {
  var n;
  e === void 0 && (e = []);
  const i = Oe(t), s = i === ((n = t.ownerDocument) == null ? void 0 : n.body), r = P(i);
  return s ? e.concat(r, r.visualViewport || [], yt(i) ? i : [], []) : e.concat(i, Ee(i, []));
}
function Qt(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Se(t) {
  const e = W(t);
  let o = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = J(t), s = i ? t.offsetWidth : o, r = i ? t.offsetHeight : n, a = wt(o) !== s || wt(n) !== r;
  return a && (o = s, n = r), {
    width: o,
    height: n,
    $: a
  };
}
function Le(t) {
  return K(t) ? t : t.contextElement;
}
function lt(t) {
  const e = Le(t);
  if (!J(e))
    return Y(1);
  const o = e.getBoundingClientRect(), {
    width: n,
    height: i,
    $: s
  } = Se(e);
  let r = (s ? wt(o.width) : o.width) / n, a = (s ? wt(o.height) : o.height) / i;
  return (!r || !Number.isFinite(r)) && (r = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: r,
    y: a
  };
}
const Ho = /* @__PURE__ */ Y(0);
function Ie(t) {
  const e = P(t);
  return !Nt() || !e.visualViewport ? Ho : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function $o(t, e, o) {
  return e === void 0 && (e = !1), !o || e && o !== P(t) ? !1 : e;
}
function ht(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), s = Le(t);
  let r = Y(1);
  e && (n ? K(n) && (r = lt(n)) : r = lt(t));
  const a = $o(s, o, n) ? Ie(s) : Y(0);
  let l = (i.left + a.x) / r.x, u = (i.top + a.y) / r.y, d = i.width / r.x, c = i.height / r.y;
  if (s) {
    const h = P(s), f = n && K(n) ? P(n) : n;
    let p = h, m = Qt(p);
    for (; m && n && f !== p; ) {
      const g = lt(m), y = m.getBoundingClientRect(), b = W(m), v = y.left + (m.clientLeft + parseFloat(b.paddingLeft)) * g.x, x = y.top + (m.clientTop + parseFloat(b.paddingTop)) * g.y;
      l *= g.x, u *= g.y, d *= g.x, c *= g.y, l += v, u += x, p = P(m), m = Qt(p);
    }
  }
  return ct({
    width: d,
    height: c,
    x: l,
    y: u
  });
}
function kt(t, e) {
  const o = _t(t).scrollLeft;
  return e ? e.left + o : ht(Q(t)).left + o;
}
function De(t, e) {
  const o = t.getBoundingClientRect(), n = o.left + e.scrollLeft - kt(t, o), i = o.top + e.scrollTop;
  return {
    x: n,
    y: i
  };
}
function Bo(t) {
  let {
    elements: e,
    rect: o,
    offsetParent: n,
    strategy: i
  } = t;
  const s = i === "fixed", r = Q(n), a = e ? Tt(e.floating) : !1;
  if (n === r || a && s)
    return o;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Y(1);
  const d = Y(0), c = J(n);
  if ((c || !c && !s) && ((ut(n) !== "body" || yt(r)) && (l = _t(n)), J(n))) {
    const f = ht(n);
    u = lt(n), d.x = f.x + n.clientLeft, d.y = f.y + n.clientTop;
  }
  const h = r && !c && !s ? De(r, l) : Y(0);
  return {
    width: o.width * u.x,
    height: o.height * u.y,
    x: o.x * u.x - l.scrollLeft * u.x + d.x + h.x,
    y: o.y * u.y - l.scrollTop * u.y + d.y + h.y
  };
}
function No(t) {
  return Array.from(t.getClientRects());
}
function Po(t) {
  const e = Q(t), o = _t(t), n = t.ownerDocument.body, i = R(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = R(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let r = -o.scrollLeft + kt(t);
  const a = -o.scrollTop;
  return W(n).direction === "rtl" && (r += R(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: s,
    x: r,
    y: a
  };
}
const te = 25;
function Uo(t, e) {
  const o = P(t), n = Q(t), i = o.visualViewport;
  let s = n.clientWidth, r = n.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, r = i.height;
    const d = Nt();
    (!d || d && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  const u = kt(n);
  if (u <= 0) {
    const d = n.ownerDocument, c = d.body, h = getComputedStyle(c), f = d.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, p = Math.abs(n.clientWidth - c.clientWidth - f);
    p <= te && (s -= p);
  } else u <= te && (s += u);
  return {
    width: s,
    height: r,
    x: a,
    y: l
  };
}
const Vo = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function jo(t, e) {
  const o = ht(t, !0, e === "fixed"), n = o.top + t.clientTop, i = o.left + t.clientLeft, s = J(t) ? lt(t) : Y(1), r = t.clientWidth * s.x, a = t.clientHeight * s.y, l = i * s.x, u = n * s.y;
  return {
    width: r,
    height: a,
    x: l,
    y: u
  };
}
function ee(t, e, o) {
  let n;
  if (e === "viewport")
    n = Uo(t, o);
  else if (e === "document")
    n = Po(Q(t));
  else if (K(e))
    n = jo(e, o);
  else {
    const i = Ie(t);
    n = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return ct(n);
}
function Ae(t, e) {
  const o = ot(t);
  return o === e || !K(o) || dt(o) ? !1 : W(o).position === "fixed" || Ae(o, e);
}
function zo(t, e) {
  const o = e.get(t);
  if (o)
    return o;
  let n = Ee(t, []).filter((a) => K(a) && ut(a) !== "body"), i = null;
  const s = W(t).position === "fixed";
  let r = s ? ot(t) : t;
  for (; K(r) && !dt(r); ) {
    const a = W(r), l = Bt(r);
    !l && a.position === "fixed" && (i = null), (s ? !l && !i : !l && a.position === "static" && !!i && Vo.has(i.position) || yt(r) && !l && Ae(t, r)) ? n = n.filter((d) => d !== r) : i = a, r = ot(r);
  }
  return e.set(t, n), n;
}
function Fo(t) {
  let {
    element: e,
    boundary: o,
    rootBoundary: n,
    strategy: i
  } = t;
  const r = [...o === "clippingAncestors" ? Tt(e) ? [] : zo(e, this._c) : [].concat(o), n], a = r[0], l = r.reduce((u, d) => {
    const c = ee(e, d, i);
    return u.top = R(c.top, u.top), u.right = G(c.right, u.right), u.bottom = G(c.bottom, u.bottom), u.left = R(c.left, u.left), u;
  }, ee(e, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Ko(t) {
  const {
    width: e,
    height: o
  } = Se(t);
  return {
    width: e,
    height: o
  };
}
function Wo(t, e, o) {
  const n = J(e), i = Q(e), s = o === "fixed", r = ht(t, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Y(0);
  function u() {
    l.x = kt(i);
  }
  if (n || !n && !s)
    if ((ut(e) !== "body" || yt(i)) && (a = _t(e)), n) {
      const f = ht(e, !0, s, e);
      l.x = f.x + e.clientLeft, l.y = f.y + e.clientTop;
    } else i && u();
  s && !n && i && u();
  const d = i && !n && !s ? De(i, a) : Y(0), c = r.left + a.scrollLeft - l.x - d.x, h = r.top + a.scrollTop - l.y - d.y;
  return {
    x: c,
    y: h,
    width: r.width,
    height: r.height
  };
}
function Ot(t) {
  return W(t).position === "static";
}
function ne(t, e) {
  if (!J(t) || W(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let o = t.offsetParent;
  return Q(t) === o && (o = o.ownerDocument.body), o;
}
function Re(t, e) {
  const o = P(t);
  if (Tt(t))
    return o;
  if (!J(t)) {
    let i = ot(t);
    for (; i && !dt(i); ) {
      if (K(i) && !Ot(i))
        return i;
      i = ot(i);
    }
    return o;
  }
  let n = ne(t, e);
  for (; n && So(n) && Ot(n); )
    n = ne(n, e);
  return n && dt(n) && Ot(n) && !Bt(n) ? o : n || Ro(t) || o;
}
const qo = async function(t) {
  const e = this.getOffsetParent || Re, o = this.getDimensions, n = await o(t.floating);
  return {
    reference: Wo(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Xo(t) {
  return W(t).direction === "rtl";
}
const Yo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Bo,
  getDocumentElement: Q,
  getClippingRect: Fo,
  getOffsetParent: Re,
  getElementRects: qo,
  getClientRects: No,
  getDimensions: Ko,
  getScale: lt,
  isElement: K,
  isRTL: Xo
}, Pt = _o, Me = go, Ut = ko, Vt = yo, He = Co, $e = wo, Be = po, Ne = vo, jt = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: Yo,
    ...o
  }, s = {
    ...i.platform,
    _c: n
  };
  return fo(t, e, {
    ...i,
    platform: s
  });
};
function Go(t, e) {
  const o = Math.min(t.top, e.top), n = Math.max(t.bottom, e.bottom), i = Math.min(t.left, e.left), r = Math.max(t.right, e.right) - i, a = n - o, l = i, u = o;
  return new DOMRect(l, u, r, a);
}
var Jo = class {
  constructor({
    editor: t,
    element: e,
    view: o,
    updateDelay: n = 250,
    resizeDelay: i = 60,
    shouldShow: s,
    appendTo: r,
    getReferencedVirtualElement: a,
    options: l
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    }, this.shouldShow = ({ view: d, state: c, from: h, to: f }) => {
      const { doc: p, selection: m } = c, { empty: g } = m, y = !p.textBetween(h, f).length && Ke(c.selection), b = this.element.contains(document.activeElement);
      return !(!(d.hasFocus() || b) || g || y || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: d }) => {
      var c;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      d != null && d.relatedTarget && ((c = this.element.parentNode) != null && c.contains(d.relatedTarget)) || (d == null ? void 0 : d.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.handleDebouncedUpdate = (d, c) => {
      const h = !(c != null && c.selection.eq(d.state.selection)), f = !(c != null && c.doc.eq(d.state.doc));
      !h && !f || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(d, h, f, c);
      }, this.updateDelay));
    }, this.updateHandler = (d, c, h, f) => {
      const { composing: p } = d;
      if (p || !c && !h)
        return;
      if (!this.getShouldShow(f)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.transactionHandler = ({ transaction: d }) => {
      const c = d.getMeta("bubbleMenu");
      c === "updatePosition" ? this.updatePosition() : c && typeof c == "object" && c.type === "updateOptions" && this.updateOptions(c.options);
    };
    var u;
    this.editor = t, this.element = e, this.view = o, this.updateDelay = n, this.resizeDelay = i, this.appendTo = r, this.scrollTarget = (u = l == null ? void 0 : l.scrollTarget) != null ? u : window, this.getReferencedVirtualElement = a, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...l
    }, this.element.tabIndex = 0, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(o, o.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const t = [];
    return this.floatingUIOptions.flip && t.push(Vt(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && t.push(
      Ut(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && t.push(
      Pt(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && t.push(Be(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && t.push(He(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && t.push(
      Me(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && t.push($e(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && t.push(
      Ne(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), t;
  }
  get virtualElement() {
    var t, e, o;
    const { selection: n } = this.editor.state, i = (t = this.getReferencedVirtualElement) == null ? void 0 : t.call(this);
    if (i)
      return i;
    if (!((o = (e = this.view) == null ? void 0 : e.dom) != null && o.parentNode))
      return;
    const s = re(this.view, n.from, n.to);
    let r = {
      getBoundingClientRect: () => s,
      getClientRects: () => [s]
    };
    if (n instanceof nn) {
      let a = this.view.nodeDOM(n.from);
      const l = a.dataset.nodeViewWrapper ? a : a.querySelector("[data-node-view-wrapper]");
      l && (a = l), a && (r = {
        getBoundingClientRect: () => a.getBoundingClientRect(),
        getClientRects: () => [a.getBoundingClientRect()]
      });
    }
    if (n instanceof on) {
      const { $anchorCell: a, $headCell: l } = n, u = a ? a.pos : l.pos, d = l ? l.pos : a.pos, c = this.view.nodeDOM(u), h = this.view.nodeDOM(d);
      if (!c || !h)
        return;
      const f = c === h ? c.getBoundingClientRect() : Go(
        c.getBoundingClientRect(),
        h.getBoundingClientRect()
      );
      r = {
        getBoundingClientRect: () => f,
        getClientRects: () => [f]
      };
    }
    return r;
  }
  updatePosition() {
    const t = this.virtualElement;
    t && jt(t, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: e, y: o, strategy: n, middlewareData: i }) => {
      var s, r;
      if ((s = i.hide) != null && s.referenceHidden || (r = i.hide) != null && r.escaped) {
        this.element.style.visibility = "hidden";
        return;
      }
      this.element.style.visibility = "visible", this.element.style.width = "max-content", this.element.style.position = n, this.element.style.left = `${e}px`, this.element.style.top = `${o}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(t, e) {
    const { state: o } = t, n = o.selection.from !== o.selection.to;
    if (this.updateDelay > 0 && n) {
      this.handleDebouncedUpdate(t, e);
      return;
    }
    const i = !(e != null && e.selection.eq(t.state.selection)), s = !(e != null && e.doc.eq(t.state.doc));
    this.updateHandler(t, i, s, e);
  }
  getShouldShow(t) {
    var e;
    const { state: o } = this.view, { selection: n } = o, { ranges: i } = n, s = Math.min(...i.map((l) => l.$from.pos)), r = Math.max(...i.map((l) => l.$to.pos));
    return ((e = this.shouldShow) == null ? void 0 : e.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: o,
      oldState: t,
      from: s,
      to: r
    })) || !1;
  }
  show() {
    var t;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const e = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (t = e ?? this.view.dom.parentElement) == null || t.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  updateOptions(t) {
    var e;
    if (t.updateDelay !== void 0 && (this.updateDelay = t.updateDelay), t.resizeDelay !== void 0 && (this.resizeDelay = t.resizeDelay), t.appendTo !== void 0 && (this.appendTo = t.appendTo), t.getReferencedVirtualElement !== void 0 && (this.getReferencedVirtualElement = t.getReferencedVirtualElement), t.shouldShow !== void 0 && t.shouldShow && (this.shouldShow = t.shouldShow), t.options !== void 0) {
      const o = (e = t.options.scrollTarget) != null ? e : window;
      o !== this.scrollTarget && (this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.scrollTarget = o, this.scrollTarget.addEventListener("scroll", this.resizeHandler)), this.floatingUIOptions = {
        ...this.floatingUIOptions,
        ...t.options
      };
    }
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, Zo = (t) => new It({
  key: typeof t.pluginKey == "string" ? new rt(t.pluginKey) : t.pluginKey,
  view: (e) => new Jo({ view: e, ...t })
}), Qo = le({
  name: "BubbleMenu",
  inheritAttrs: !1,
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    resizeDelay: {
      type: Number,
      default: void 0
    },
    options: {
      type: Object,
      default: () => ({})
    },
    appendTo: {
      type: [Object, Function],
      default: void 0
    },
    shouldShow: {
      type: Function,
      default: null
    },
    getReferencedVirtualElement: {
      type: Function,
      default: void 0
    }
  },
  setup(t, { slots: e, attrs: o }) {
    const n = ce(null);
    return de(() => {
      const {
        editor: i,
        options: s,
        pluginKey: r,
        resizeDelay: a,
        appendTo: l,
        shouldShow: u,
        getReferencedVirtualElement: d,
        updateDelay: c
      } = t, h = n.value;
      h && (h.style.visibility = "hidden", h.style.position = "absolute", h.remove(), sn(() => {
        i.registerPlugin(
          Zo({
            editor: i,
            element: h,
            options: s,
            pluginKey: r,
            resizeDelay: a,
            appendTo: l,
            shouldShow: u,
            getReferencedVirtualElement: d,
            updateDelay: c
          })
        );
      }));
    }), ue(() => {
      const { pluginKey: i, editor: s } = t;
      s.unregisterPlugin(i);
    }), () => {
      var i;
      return he("div", { ref: n, ...o }, (i = e.default) == null ? void 0 : i.call(e));
    };
  }
}), ti = class {
  constructor({
    editor: t,
    element: e,
    view: o,
    updateDelay: n = 250,
    resizeDelay: i = 60,
    options: s,
    appendTo: r,
    shouldShow: a
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.shouldShow = ({ view: u, state: d }) => {
      const { selection: c } = d, { $anchor: h, empty: f } = c, p = h.depth === 1, m = h.parent.isTextblock && !h.parent.type.spec.code && !h.parent.textContent && h.parent.childCount === 0 && !this.getTextContent(h.parent);
      return !(!u.hasFocus() || !f || !p || !m || !this.editor.isEditable);
    }, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "right",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1
    }, this.updateHandler = (u, d, c, h) => {
      const { composing: f } = u;
      if (f || !d && !c)
        return;
      if (!this.getShouldShow(h)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: u }) => {
      var d;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      u != null && u.relatedTarget && ((d = this.element.parentNode) != null && d.contains(u.relatedTarget)) || (u == null ? void 0 : u.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.transactionHandler = ({ transaction: u }) => {
      const d = u.getMeta("floatingMenu");
      d === "updatePosition" ? this.updatePosition() : d && typeof d == "object" && d.type === "updateOptions" && this.updateOptions(d.options);
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    };
    var l;
    this.editor = t, this.element = e, this.view = o, this.updateDelay = n, this.resizeDelay = i, this.appendTo = r, this.scrollTarget = (l = s == null ? void 0 : s.scrollTarget) != null ? l : window, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...s
    }, this.element.tabIndex = 0, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(o, o.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  getTextContent(t) {
    return We(t, { textSerializers: qe(this.editor.schema) });
  }
  get middlewares() {
    const t = [];
    return this.floatingUIOptions.flip && t.push(Vt(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && t.push(
      Ut(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && t.push(
      Pt(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && t.push(Be(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && t.push(He(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && t.push(
      Me(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && t.push($e(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && t.push(
      Ne(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), t;
  }
  getShouldShow(t) {
    var e;
    const { state: o } = this.view, { selection: n } = o, { ranges: i } = n, s = Math.min(...i.map((l) => l.$from.pos)), r = Math.max(...i.map((l) => l.$to.pos));
    return (e = this.shouldShow) == null ? void 0 : e.call(this, {
      editor: this.editor,
      view: this.view,
      state: o,
      oldState: t,
      from: s,
      to: r
    });
  }
  updateOptions(t) {
    var e;
    if (t.updateDelay !== void 0 && (this.updateDelay = t.updateDelay), t.resizeDelay !== void 0 && (this.resizeDelay = t.resizeDelay), t.appendTo !== void 0 && (this.appendTo = t.appendTo), t.shouldShow !== void 0 && t.shouldShow && (this.shouldShow = t.shouldShow), t.options !== void 0) {
      const o = (e = t.options.scrollTarget) != null ? e : window;
      o !== this.scrollTarget && (this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.scrollTarget = o, this.scrollTarget.addEventListener("scroll", this.resizeHandler)), this.floatingUIOptions = {
        ...this.floatingUIOptions,
        ...t.options
      };
    }
  }
  updatePosition() {
    const { selection: t } = this.editor.state, e = re(this.view, t.from, t.to);
    jt({
      getBoundingClientRect: () => e,
      getClientRects: () => [e]
    }, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: n, y: i, strategy: s, middlewareData: r }) => {
      var a, l;
      if ((a = r.hide) != null && a.referenceHidden || (l = r.hide) != null && l.escaped) {
        this.element.style.visibility = "hidden";
        return;
      }
      this.element.style.visibility = "visible", this.element.style.width = "max-content", this.element.style.position = s, this.element.style.left = `${n}px`, this.element.style.top = `${i}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(t, e) {
    const o = !(e != null && e.selection.eq(t.state.selection)), n = !(e != null && e.doc.eq(t.state.doc));
    this.updateHandler(t, o, n, e);
  }
  show() {
    var t;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const e = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (t = e ?? this.view.dom.parentElement) == null || t.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, ei = (t) => new It({
  key: typeof t.pluginKey == "string" ? new rt(t.pluginKey) : t.pluginKey,
  view: (e) => new ti({ view: e, ...t })
});
le({
  name: "FloatingMenu",
  inheritAttrs: !1,
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    resizeDelay: {
      type: Number,
      default: void 0
    },
    options: {
      type: Object,
      default: () => ({})
    },
    appendTo: {
      type: [Object, Function],
      default: void 0
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(t, { slots: e, attrs: o }) {
    const n = ce(null);
    return de(() => {
      const { pluginKey: i, editor: s, updateDelay: r, resizeDelay: a, options: l, appendTo: u, shouldShow: d } = t, c = n.value;
      c && (c.style.visibility = "hidden", c.style.position = "absolute", c.remove(), s.registerPlugin(
        ei({
          pluginKey: i,
          editor: s,
          element: c,
          updateDelay: r,
          resizeDelay: a,
          options: l,
          appendTo: u,
          shouldShow: d
        })
      ));
    }), ue(() => {
      const { pluginKey: i, editor: s } = t;
      s.unregisterPlugin(i);
    }), () => {
      var i;
      return he("div", { ref: n, ...o }, (i = e.default) == null ? void 0 : i.call(e));
    };
  }
});
const ni = {
  compatConfig: { MODE: 3 },
  name: "EmojiComponent",
  components: {
    NodeViewWrapper: pt,
    DtEmoji: ye
  },
  props: ft
};
function oi(t, e, o, n, i, s) {
  const r = T("dt-emoji"), a = T("node-view-wrapper");
  return k(), M(a, { class: "d-d-inline-block d-va-bottom d-lh0" }, {
    default: C(() => [
      I(r, {
        size: "500",
        code: t.node.attrs.code
      }, null, 8, ["code"])
    ]),
    _: 1
  });
}
const ii = /* @__PURE__ */ q(ni, [["render", oi]]), si = {
  compatConfig: { MODE: 3 },
  name: "SuggestionList",
  components: {
    DtListItem: Vn
  },
  props: {
    items: {
      type: Array,
      required: !0
    },
    command: {
      type: Function,
      required: !0
    },
    itemComponent: {
      type: Object,
      required: !0
    },
    itemType: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      selectedIndex: 0
    };
  },
  watch: {
    items() {
      this.selectedIndex = 0;
    }
  },
  methods: {
    onKeyDown({ event: t }) {
      return t.key === "ArrowUp" ? (this.upHandler(), !0) : t.key === "ArrowDown" ? (this.downHandler(), !0) : t.key === "Enter" || t.key === "Tab" ? (this.selectHandler(), !0) : !1;
    },
    upHandler() {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length, this.scrollActiveElementIntoView();
    },
    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length, this.scrollActiveElementIntoView();
    },
    async scrollActiveElementIntoView() {
      await this.$nextTick();
      const t = this.$refs.suggestionList.querySelector(".d-list-item--highlighted");
      t && t.scrollIntoView({
        behaviour: "smooth",
        block: "center"
      });
    },
    selectHandler() {
      this.selectItem(this.selectedIndex);
    },
    selectItem(t) {
      const e = this.items[t];
      switch (this.itemType) {
        case "emoji":
          this.command(e);
          return;
        case "mention":
          this.command({ name: e.name, id: e.id, avatarSrc: e.avatarSrc, contactKey: e.contactKey });
          break;
        case "channel":
          this.command({ name: e.name, id: e.id, locked: e.locked, channelKey: e.channelKey });
          break;
        case "slash-command":
          this.command({ command: e.command });
          break;
      }
    }
  }
}, ri = { class: "d-popover__dialog d-suggestion-list__container" }, ai = {
  ref: "suggestionList",
  class: "d-suggestion-list"
};
function li(t, e, o, n, i, s) {
  const r = T("dt-list-item");
  return k(), et("div", ri, [
    rn(nt("ul", ai, [
      (k(!0), et(an, null, ln(o.items, (a, l) => (k(), M(r, {
        key: a.id,
        class: fe([
          "d-suggestion-list__item",
          { "d-list-item--highlighted": l === i.selectedIndex }
        ]),
        "navigation-type": "arrow-keys",
        onClick: (u) => s.selectItem(l),
        onKeydown: Dt(s.onKeyDown, ["prevent"])
      }, {
        default: C(() => [
          (k(), M(cn(o.itemComponent), { item: a }, null, 8, ["item"]))
        ]),
        _: 2
      }, 1032, ["class", "onClick", "onKeydown"]))), 128))
    ], 512), [
      [dn, o.items.length]
    ])
  ]);
}
const ci = /* @__PURE__ */ q(si, [["render", li]]), Pe = "top-start", Ue = "650";
function di() {
  return {
    getBoundingClientRect: () => ({
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    })
  };
}
function oe(t) {
  return { getBoundingClientRect: t };
}
async function ui(t, e, o = {}) {
  if (!t || !(e != null && e.getBoundingClientRect)) return;
  const {
    placement: n = Pe,
    middleware: i = [Pt(0), Vt(), Ut({ padding: 8 })]
  } = o, { x: s, y: r } = await jt(e, t, {
    placement: n,
    middleware: i
  });
  Object.assign(t.style, {
    left: `${s}px`,
    top: `${r}px`
  });
}
function hi(t, e = {}) {
  const { zIndex: o = Ue } = e;
  t.style.position = "absolute", t.style.zIndex = o, t.style.display = "none";
}
function fi(t) {
  t && (t.style.display = "block");
}
function pi(t) {
  t && (t.style.display = "none");
}
function mi(t, e) {
  return (o) => {
    o.key === "Escape" && e() && t();
  };
}
function gi(t) {
  document.addEventListener("keydown", t);
}
function yi(t) {
  document.removeEventListener("keydown", t);
}
function wi(t, e, o, n) {
  return new je(t, {
    props: {
      itemComponent: un(e),
      itemType: o,
      ...n
    },
    editor: n.editor
  });
}
function bi(t) {
  var e, o;
  t.escHandler && yi(t.escHandler), (e = t.floatingEl) == null || e.remove(), (o = t.component) == null || o.destroy();
}
function Ct(t, e, o = {}) {
  const {
    listComponent: n = ci,
    placement: i = Pe,
    zIndex: s = Ue
  } = o;
  return () => {
    let r = null, a = null, l = !1, u = di(), d = null;
    function c() {
      ui(a, u, { placement: i });
    }
    function h() {
      a && (fi(a), l = !0, c());
    }
    function f() {
      a && (pi(a), l = !1);
    }
    return {
      onStart: (p) => {
        r = wi(n, t, e, p), p.clientRect && (a = r.element, hi(a, { zIndex: s }), document.body.appendChild(a), u = oe(p.clientRect), d = mi(f, () => l), gi(d), p.items.length > 0 && h());
      },
      onUpdate(p) {
        r == null || r.updateProps(p), p.items.length > 0 ? h() : f(), p.clientRect && (u = oe(p.clientRect), c());
      },
      onKeyDown(p) {
        var m;
        if (l)
          return (m = r == null ? void 0 : r.ref) == null ? void 0 : m.onKeyDown(p);
      },
      onExit() {
        bi({ escHandler: d, floatingEl: a, component: r }), d = null, a = null, r = null;
      }
    };
  };
}
const vi = {
  compatConfig: { MODE: 3 },
  name: "EmojiSuggestion",
  components: {
    DtEmoji: ye,
    DtStack: gt
  },
  props: {
    item: {
      type: Object,
      required: !0
    }
  }
};
function xi(t, e, o, n, i, s) {
  const r = T("dt-emoji"), a = T("dt-stack");
  return k(), M(a, {
    direction: "row",
    gap: "400"
  }, {
    default: C(() => [
      I(r, {
        size: "200",
        code: o.item.code
      }, null, 8, ["code"]),
      at(" " + $(o.item.code), 1)
    ]),
    _: 1
  });
}
const Ti = /* @__PURE__ */ q(vi, [["render", xi]]), _i = 20, ki = (t, e, o) => {
  var a, l;
  const n = (a = t.shortname) == null ? void 0 : a.replaceAll(":", ""), i = (l = e.shortname) == null ? void 0 : l.replaceAll(":", ""), s = n.startsWith(o), r = i.startsWith(o);
  return s && !r ? -1 : !s && r ? 1 : n.localeCompare(i);
}, Ci = {
  items: ({ query: t }) => {
    if (t.length < 2)
      return [];
    const e = Object.values(Bn());
    return t = t.toLowerCase(), e.filter(
      (n) => {
        var i;
        return [
          n.name,
          (i = n.shortname) == null ? void 0 : i.replaceAll(":", ""),
          ...n.keywords || []
        ].some((s) => s && s.startsWith(t));
      }
    ).splice(0, _i).sort((n, i) => ki(n, i, t)).map((n) => ({ code: n.shortname }));
  },
  command: ({ editor: t, range: e, props: o }) => {
    var s, r;
    const n = t.view.state.selection.$to.nodeAfter;
    ((s = n == null ? void 0 : n.text) == null ? void 0 : s.startsWith(" ")) && (e.to += 1), t.chain().focus().insertContentAt(e, [
      {
        type: "emoji",
        attrs: o
      }
    ]).run(), (r = window.getSelection()) == null || r.collapseToEnd();
  },
  render: Ct(Ti, "emoji")
}, Oi = /(:\w+:)$/, Ei = new RegExp(ge + "$"), Si = (t) => {
  if (t && At(t[0]))
    return { text: t[2] || t[0] };
}, Li = (t) => [...t.matchAll(Un)].filter((o) => At(o[0])).map((o) => ({
  index: o.index,
  text: o[0],
  match: o
})), Ii = ae.create({
  name: "emoji",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "inline",
  inline: !0,
  selectable: !1,
  atom: !0,
  addNodeView() {
    return mt(ii);
  },
  addAttributes() {
    return {
      code: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "emoji-component"
      }
    ];
  },
  renderText({ node: t }) {
    return Pn(At(t.attrs.code).unicode_output);
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["emoji-component", st(this.options.HTMLAttributes, t)];
  },
  addInputRules() {
    return [
      new Xe({
        find: (t) => {
          const e = t.match(Oi) || t.match(Ei);
          if (e)
            return Si(e);
        },
        handler: ({ state: t, range: e, match: o }) => {
          const { tr: n } = t, i = e.from, s = e.to;
          n.replaceWith(i, s, this.type.create({ code: o[0] }));
        }
      })
    ];
  },
  addPasteRules() {
    return [
      Et({
        find: Li,
        type: this.type,
        getAttributes(t) {
          return {
            code: t[0]
          };
        }
      }),
      Et({
        find: Nn,
        type: this.type,
        getAttributes(t) {
          return {
            code: t[0]
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      $n({
        char: ":",
        pluginKey: new rt("emoji"),
        editor: this.editor,
        ...this.options.suggestion,
        ...Ci
      })
    ];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: t, state: e }) => {
        let o = !1;
        const { selection: n } = e, { empty: i, anchor: s } = n;
        return i ? (e.doc.nodesBetween(s - 1, s, (r, a) => {
          if (r.type.name === this.name)
            return o = !0, t.insertText("", a, a + r.nodeSize), !1;
        }), o) : !1;
      })
    };
  }
});
function Di(t, e, o = () => !0) {
  const n = [];
  e.lastIndex = 0;
  let i;
  for (; i = e.exec(t); )
    o(t, i) && n.push(i);
  return n;
}
function Ai(t, e) {
  return !["#", "@"].includes(t.charAt(e.index)) && !["#", "@"].includes(t.charAt(e.index - 1));
}
function Ri(t) {
  const e = new RegExp(
    "(?:" + [
      `[!?.,:;'"]`,
      "(?:&|&amp;)(?:lt|gt|quot|apos|raquo|laquo|rsaquo|lsaquo);)+$"
    ].join("|"),
    "g"
  );
  return t.replace(e, "");
}
function Mi(t, e) {
  const o = t.slice(0, e + 1).search(/\S+\s*$/), n = t.slice(e).search(/\s/);
  if (n < 0) {
    const i = t.slice(o);
    return {
      text: i,
      from: o,
      to: o + i.length
    };
  }
  return {
    text: t.slice(o, n + e),
    from: o,
    to: n + e
  };
}
function Lt(t, e, o, n) {
  const i = Mi(t, e);
  if (n.lastIndex = 0, !n.test(i.text))
    return i;
  const s = o === "left" ? i.from - 1 : i.to + 1;
  return s <= 0 || s >= t.length || s === e ? i : Lt(t, s, o, n);
}
function Hi(t, e, o, n) {
  const i = Math.max(t.from - 1, 0), s = Math.min(t.to + 1, e.content.size), r = Ye(i, s, e);
  for (const a of r)
    a.mark.type === n && o.removeMark(a.from, a.to, n);
}
const ie = zn(1, 15);
function se(t, e, o, n, i, s) {
  if (!t)
    return;
  let r = o - e - 1;
  r = r < 0 ? 0 : r;
  const a = n - e, l = Lt(
    t,
    r,
    "left",
    ie
  ), u = Lt(
    t,
    a,
    "right",
    ie
  ), d = t.slice(l.from, u.to);
  Di(d, jn, Ai).forEach((h) => {
    const f = Ri(h[0]), p = e + l.from + h.index + 1, m = p + f.length;
    i.addMark(p, m, s.create());
  });
}
function $i(t) {
  let e = !1;
  return new It({
    key: new rt("autolink"),
    appendTransaction: (o, n, i) => {
      const s = o.some((d) => d.docChanged) && !n.doc.eq(i.doc);
      if (e && !s)
        return;
      const { tr: r } = i, { textContent: a } = i.doc;
      e || se(a, 0, 0, a.length, r, t.type), e = !0;
      const l = Ge(
        n.doc,
        [...o]
      );
      return Je(l).forEach(({ oldRange: d, newRange: c }) => {
        Hi(c, i.doc, r, t.type), Ze(
          i.doc,
          c,
          (f) => f.isTextblock
        ).forEach(({ node: f, pos: p }) => {
          se(
            f.textContent,
            p,
            d.from,
            c.to,
            r,
            t.type
          );
        });
      }), r;
    }
  });
}
const Bi = {
  class: "d-link d-c-text d-d-inline-block d-wb-break-all",
  rel: "noopener noreferrer nofollow"
}, Ni = Qe.create({
  name: "CustomLink",
  renderHTML({ HTMLAttributes: t }) {
    return [
      "a",
      st(
        this.options.HTMLAttributes,
        t,
        Bi
      )
    ];
  },
  renderText({ node: t }) {
    return t.attrs.text;
  },
  addProseMirrorPlugins() {
    return [
      $i({ type: this.type })
    ];
  }
}), Pi = Kn.extend({
  name: "ConfigurableImage",
  addAttributes() {
    return {
      src: {
        default: ""
      },
      alt: {
        default: void 0
      },
      title: {
        default: void 0
      },
      width: {
        default: void 0
      },
      height: {
        default: void 0
      },
      style: {
        default: void 0
      }
    };
  }
}).configure({ inline: !0, allowBase64: !0 }), Ui = me.extend({
  parseHTML() {
    return [{ tag: "div" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["div", st(this.options.HTMLAttributes, t), 0];
  }
}), Vi = {
  compatConfig: { MODE: 3 },
  name: "MentionComponent",
  components: {
    NodeViewWrapper: pt,
    DtLink: we
  },
  props: ft,
  computed: {
    text() {
      return "@" + this.$props.node.attrs.name;
    }
  },
  methods: {
    getMentionData() {
      return {
        name: this.$props.node.attrs.name,
        id: this.$props.node.attrs.id,
        avatarSrc: this.$props.node.attrs.avatarSrc,
        contactKey: this.$props.node.attrs.contactKey
      };
    },
    handleClick() {
      this.$props.editor.emit("mention-click", this.getMentionData());
    },
    handleMouseEnter(t) {
      this.$props.editor.emit("mention-hover", { ...this.getMentionData(), event: t });
    },
    handleMouseLeave(t) {
      this.$props.editor.emit("mention-leave", { ...this.getMentionData(), event: t });
    }
  }
};
function ji(t, e, o, n, i, s) {
  const r = T("dt-link"), a = T("node-view-wrapper");
  return k(), M(a, { class: "d-d-inline-block" }, {
    default: C(() => [
      I(r, {
        kind: "mention",
        onClick: Dt(s.handleClick, ["prevent"]),
        onMouseenter: s.handleMouseEnter,
        onMouseleave: s.handleMouseLeave,
        onFocusin: s.handleMouseEnter,
        onFocusout: s.handleMouseLeave
      }, {
        default: C(() => [
          at($(s.text), 1)
        ]),
        _: 1
      }, 8, ["onClick", "onMouseenter", "onMouseleave", "onFocusin", "onFocusout"])
    ]),
    _: 1
  });
}
const zi = /* @__PURE__ */ q(Vi, [["render", ji]]), Fi = Rt.extend({
  addNodeView() {
    return mt(zi);
  },
  parseHTML() {
    return [
      {
        tag: "mention-component"
      }
    ];
  },
  addAttributes() {
    return {
      name: {
        default: ""
      },
      avatarSrc: {
        default: ""
      },
      id: {
        default: ""
      },
      contactKey: {
        default: ""
      }
    };
  },
  renderText({ node: t }) {
    return `@${t.attrs.id}`;
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mention-component", st(this.options.HTMLAttributes, t)];
  }
}).configure({
  suggestion: {
    char: "@",
    pluginKey: new rt("mentionSuggestion")
  }
}), Ki = {
  compatConfig: { MODE: 3 },
  name: "ChannelComponent",
  components: {
    NodeViewWrapper: pt,
    DtLink: we,
    DtIconLock: Wn,
    DtStack: gt
  },
  props: ft,
  computed: {
    text() {
      return this.$props.node.attrs.locked ? this.$props.node.attrs.name : "#" + this.$props.node.attrs.name;
    }
  },
  methods: {
    handleClick() {
      const t = {
        name: this.$props.node.attrs.name,
        id: this.$props.node.attrs.id,
        locked: this.$props.node.attrs.locked,
        channelKey: this.$props.node.attrs.channelKey
      };
      this.$props.editor.emit("channel-click", t);
    }
  }
};
function Wi(t, e, o, n, i, s) {
  const r = T("dt-icon-lock"), a = T("dt-stack"), l = T("dt-link"), u = T("node-view-wrapper");
  return k(), M(u, { class: "d-d-inline-block" }, {
    default: C(() => [
      I(l, {
        kind: "mention",
        onClick: Dt(s.handleClick, ["prevent"])
      }, {
        default: C(() => [
          I(a, {
            direction: "row",
            gap: "0"
          }, {
            default: C(() => [
              t.$props.node.attrs.locked ? (k(), M(r, {
                key: 0,
                size: "200"
              })) : it("", !0),
              nt("span", null, $(s.text), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  });
}
const qi = /* @__PURE__ */ q(Ki, [["render", Wi]]), Xi = Rt.extend({
  name: "channel",
  addNodeView() {
    return mt(qi);
  },
  parseHTML() {
    return [
      {
        tag: "channel-component"
      }
    ];
  },
  addAttributes() {
    return {
      name: {
        default: ""
      },
      id: {
        default: ""
      },
      locked: {
        default: !1
      },
      channelKey: {
        default: ""
      }
    };
  },
  renderText({ node: t }) {
    return `#${t.attrs.id}`;
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["channel-component", st(this.options.HTMLAttributes, t)];
  }
}).configure({
  suggestion: {
    char: "#",
    pluginKey: new rt("channelSuggestion")
  }
}), Yi = {
  compatConfig: { MODE: 3 },
  name: "SlashCommandsComponent",
  components: {
    NodeViewWrapper: pt
  },
  props: {
    ...ft
  },
  emits: ["selected-command"],
  computed: {
    text() {
      return "/" + this.$props.node.attrs.command;
    }
  },
  created() {
    var o, n, i;
    const t = this.$props.node.attrs.command;
    this.$emit("selected-command", t);
    const e = (i = (n = (o = this.editor) == null ? void 0 : o.storage) == null ? void 0 : n["slash-commands"]) == null ? void 0 : i.onSelectedCommand;
    e && typeof e == "function" && e(t);
  }
};
function Gi(t, e, o, n, i, s) {
  const r = T("node-view-wrapper");
  return k(), M(r, { class: "d-d-inline-block" }, {
    default: C(() => [
      at($(s.text), 1)
    ]),
    _: 1
  });
}
const Ji = /* @__PURE__ */ q(Yi, [["render", Gi]]), Zi = (t, e) => [...t.matchAll(e)].map((n) => {
  let i = n[2];
  return i.endsWith(" ") || (i += " "), {
    index: n.index,
    text: i,
    match: n
  };
}), Qi = Rt.extend({
  name: "slash-commands",
  group: "inline",
  inline: !0,
  addOptions() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      onSelectedCommand: null
    };
  },
  addStorage() {
    return {
      onSelectedCommand: this.options.onSelectedCommand
    };
  },
  addNodeView() {
    return mt(Ji);
  },
  parseHTML() {
    return [
      {
        tag: "command-component"
      }
    ];
  },
  addAttributes() {
    return {
      command: {
        default: ""
      },
      parametersExample: {
        default: ""
      },
      description: {
        default: ""
      }
    };
  },
  renderText({ node: t }) {
    return `/${t.attrs.command}`;
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["command-component", st(this.options.HTMLAttributes, t)];
  },
  addInputRules() {
    var o;
    const t = (o = this.options.suggestion) == null ? void 0 : o.items({ query: "" }).map((n) => n.command), e = new RegExp(`^((?:\\/)(${t.join("|")})) $`);
    return [
      tn({
        find: e,
        type: this.type,
        getAttributes(n) {
          return { command: n[2] };
        }
      })
    ];
  },
  addPasteRules() {
    var o;
    const t = (o = this.options.suggestion) == null ? void 0 : o.items({ query: "" }).map((n) => n.command), e = new RegExp(`^((?:\\/)(${t.join("|")})) ?$`, "g");
    return [
      Et({
        find: (n) => Zi(n, e),
        type: this.type,
        getAttributes(n) {
          return { command: n[0].trim() };
        }
      })
    ];
  }
}).configure({
  suggestion: {
    char: "/",
    pluginKey: new rt("slashCommandSuggestion")
  }
}), ts = 100, es = {
  name: "VariableComponent",
  components: {
    DtBadge: Yn,
    DtButton: ve,
    DtPopover: Xn,
    DtInput: qn,
    NodeViewWrapper: pt
  },
  props: ft,
  data() {
    return {
      i18n: new be(),
      MAX_VARIABLE_ALT_LENGTH: ts
    };
  },
  computed: {
    altText: {
      get() {
        var t, e;
        return ((e = (t = this.node) == null ? void 0 : t.attrs) == null ? void 0 : e.altText) || "";
      },
      set(t) {
        this.updateAttributes({ altText: t });
      }
    },
    variableId() {
      var t, e;
      return (e = (t = this.node) == null ? void 0 : t.attrs) == null ? void 0 : e.id;
    },
    placeholder() {
      var t;
      return ((t = this.variableData) == null ? void 0 : t.placeholder) || "";
    },
    variableItems() {
      var t, e;
      return ((e = (t = this.extension) == null ? void 0 : t.options) == null ? void 0 : e.variableItems) || [];
    },
    variableData() {
      return this.variableItems.find((t) => t.id === this.variableId);
    },
    badgeLabel() {
      return `{} ${this.placeholder}`;
    },
    placeholderText() {
      return `Replaces ${this.placeholder}`;
    }
  }
};
function ns(t, e, o, n, i, s) {
  const r = T("dt-badge"), a = T("dt-button"), l = T("dt-input"), u = T("dt-popover"), d = T("node-view-wrapper");
  return k(), M(d, { class: "d-d-inline-block" }, {
    default: C(() => [
      I(u, {
        padding: "small",
        "navigation-type": "arrow-keys",
        placement: "top-start",
        modal: !1
      }, {
        anchor: C(({ attrs: c }) => [
          I(a, pe(c, { kind: "unstyled" }), {
            default: C(() => [
              I(r, {
                text: s.badgeLabel,
                contenteditable: "false"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 16)
        ]),
        content: C(({ close: c }) => [
          I(l, {
            modelValue: s.altText,
            "onUpdate:modelValue": e[0] || (e[0] = (h) => s.altText = h),
            "root-class": "d-p8 d-w332",
            label: i.i18n.$t("DIALTONE_EDITOR_VARIABLE_LABEL"),
            placeholder: s.placeholderText,
            validate: {
              length: {
                description: i.i18n.$t("DIALTONE_EDITOR_VARIABLE_VALIDATE_DESCRIPTION"),
                message: i.i18n.$t("DIALTONE_EDITOR_VARIABLE_VALIDATE_MESSAGE"),
                max: i.MAX_VARIABLE_ALT_LENGTH,
                warn: i.MAX_VARIABLE_ALT_LENGTH,
                limitMaxLength: !0
              }
            },
            onKeyup: hn((h) => c(), ["enter"])
          }, null, 8, ["modelValue", "label", "placeholder", "validate", "onKeyup"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const os = /* @__PURE__ */ q(es, [["render", ns]]), is = ae.create({
  name: "variable",
  group: "inline",
  inline: !0,
  selectable: !0,
  atom: !0,
  addOptions() {
    return {
      HTMLAttributes: {},
      variableItems: []
    };
  },
  addNodeView() {
    return mt(os);
  },
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-variable-id"),
        renderHTML: (t) => t.id ? {
          "data-variable-id": t.id
        } : {}
      },
      altText: {
        default: "",
        parseHTML: (t) => t.getAttribute("data-alt-text"),
        renderHTML: (t) => t.altText ? {
          "data-alt-text": t.altText
        } : {}
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "variable"
      }
    ];
  },
  renderText({ node: t }) {
    return t.attrs.altText;
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "variable",
      st(this.options.HTMLAttributes, e, {
        "data-variable-id": t.attrs.id,
        "data-alt-text": t.attrs.altText
      })
    ];
  },
  addCommands() {
    return {
      insertVariable: (t = {}) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: {
          id: t.id || null,
          altText: t.altText || ""
        }
      })
    };
  }
}), ss = {
  compatConfig: { MODE: 3 },
  name: "MentionSuggestion",
  components: {
    DtAvatar: Zn,
    DtStack: gt
  },
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    name() {
      return this.item.name;
    },
    avatarSrc() {
      return this.item.avatarSrc;
    },
    presence() {
      return this.item.presence;
    },
    status() {
      return this.item.status;
    },
    presenceText() {
      return this.item.presenceText;
    },
    presenceFontColorClass() {
      return {
        active: "d-recipe-contact-row--active",
        busy: "d-recipe-contact-row--busy",
        away: "d-recipe-contact-row--away",
        offline: "d-recipe-contact-row--busy"
      }[this.presence];
    },
    showDetails() {
      return this.item.showDetails;
    }
  }
}, rs = { class: "d-mention-suggestion__name" }, as = {
  key: 1,
  class: "d-mention-suggestion__divider"
}, ls = {
  key: 2,
  class: "d-mention-suggestion__status"
};
function cs(t, e, o, n, i, s) {
  const r = T("dt-avatar"), a = T("dt-stack");
  return k(), M(a, {
    direction: "row",
    class: "d-mention-suggestion__container",
    gap: "400"
  }, {
    default: C(() => [
      I(r, {
        "full-name": s.name,
        "image-src": s.avatarSrc,
        "image-alt": s.name,
        "show-presence": s.showDetails,
        presence: s.presence,
        size: "sm"
      }, null, 8, ["full-name", "image-src", "image-alt", "show-presence", "presence"]),
      I(a, {
        class: "d-mention-suggestion__details-container",
        gap: "100"
      }, {
        default: C(() => [
          nt("span", rs, $(s.name), 1),
          s.showDetails ? (k(), M(a, {
            key: 0,
            direction: "row",
            gap: "300",
            class: "d-label--sm-plain"
          }, {
            default: C(() => [
              s.presenceText ? (k(), et("span", {
                key: 0,
                class: fe(["d-mention-suggestion__presence", [s.presenceFontColorClass]])
              }, $(s.presenceText), 3)) : it("", !0),
              s.status && s.presenceText ? (k(), et("div", as, " • ")) : it("", !0),
              s.status ? (k(), et("div", ls, $(s.status), 1)) : it("", !0)
            ]),
            _: 1
          })) : it("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const ds = /* @__PURE__ */ q(ss, [["render", cs]]), us = {
  // This function comes from the user and passed to the editor directly.
  // This will also activate the mention plugin on the editor
  // items: ({ query }) => { return [] },
  allowSpaces: !0,
  render: Ct(ds, "mention")
}, hs = {
  compatConfig: { MODE: 3 },
  name: "ChannelSuggestion",
  components: {
    DtStack: gt,
    DtIconHash: Qn,
    DtIconLock: to
  },
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    name() {
      return this.item.name;
    }
  }
};
function fs(t, e, o, n, i, s) {
  const r = T("dt-icon-hash"), a = T("dt-icon-lock"), l = T("dt-stack");
  return k(), M(l, {
    direction: "row",
    gap: "400"
  }, {
    default: C(() => [
      o.item.locked ? (k(), M(a, {
        key: 1,
        size: "300"
      })) : (k(), M(r, {
        key: 0,
        size: "300"
      })),
      nt("span", null, $(s.name), 1)
    ]),
    _: 1
  });
}
const ps = /* @__PURE__ */ q(hs, [["render", fs]]), ms = {
  // This function comes from the user and passed to the editor directly.
  // This will also activate the mention plugin on the editor
  // items: ({ query }) => { return [] },
  allowSpaces: !0,
  render: Ct(ps, "channel")
}, gs = {
  compatConfig: { MODE: 3 },
  name: "SlashCommandSuggestion",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    command() {
      return this.item.command;
    },
    description() {
      return this.item.description;
    },
    parametersExample() {
      return this.item.parametersExample;
    }
  }
}, ys = { class: "d-body--md-compact" }, ws = { key: 0 }, bs = { class: "d-body--sm d-fc-tertiary" };
function vs(t, e, o, n, i, s) {
  return k(), et("div", null, [
    nt("div", ys, [
      nt("span", null, "/" + $(s.command), 1),
      s.parametersExample ? (k(), et("span", ws, $(s.parametersExample), 1)) : it("", !0)
    ]),
    nt("div", bs, $(s.description), 1)
  ]);
}
const xs = /* @__PURE__ */ q(gs, [["render", vs]]), Ts = {
  // This function comes from the user and passed to the editor directly.
  // This will also activate the mention plugin on the editor
  // items: ({ query }) => { return [] },
  allowSpaces: !0,
  startOfLine: !0,
  render: Ct(xs, "slash-command")
}, _s = {
  compatConfig: { MODE: 3 },
  name: "DtRichTextEditor",
  components: {
    EditorContent: ze,
    BubbleMenu: Qo,
    DtButton: ve,
    DtStack: gt
  },
  props: {
    /**
     * Value of the input. The object format should match TipTap's JSON
     * document structure: https://tiptap.dev/guide/output#option-1-json
     */
    modelValue: {
      type: [Object, String],
      default: ""
    },
    /**
     * Whether the input is editable
     */
    editable: {
      type: Boolean,
      default: !0
    },
    /**
     * Prevents the user from typing any further. Deleting text will still work.
     */
    preventTyping: {
      type: Boolean,
      default: !1
    },
    /**
     * When this option is false the editor will only ever paste plain text, no rich text formatting will be applied,
     * and any HTML will be rendered as text.
     */
    pasteRichText: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for line breaks to be introduced in the text by pressing enter. If this is disabled,
     * line breaks can still be entered by pressing shift+enter.
     */
    allowLineBreaks: {
      type: Boolean,
      default: !1
    },
    /**
     * Descriptive label for the input element
     */
    inputAriaLabel: {
      type: String,
      required: !0
    },
    /**
     * Additional class name for the input element. Only accepts a String value
     * because this is passed to the editor via options. For multiple classes,
     * join them into one string, e.g. "d-p8 d-hmx96"
     */
    inputClass: {
      type: String,
      default: ""
    },
    /**
     * Whether the input should receive focus after the component has been
     * mounted. Either one of `start`, `end`, `all` or a Boolean or a Number.
     * - `start`  Sets the focus to the beginning of the input
     * - `end`    Sets the focus to the end of the input
     * - `all`    Selects the whole contents of the input
     * - `Number` Sets the focus to a specific position in the input
     * - `true`   Defaults to `start`
     * - `false`  Disables autofocus
     * @values true, false, start, end, all, number
     */
    autoFocus: {
      type: [Boolean, String, Number],
      default: !1,
      validator(t) {
        return typeof t == "string" ? Jn.includes(t) : !0;
      }
    },
    /**
     * The output format that the editor uses when emitting the "@input" event.
     * One of `text`, `json`, `html`, `markdown`. See https://tiptap.dev/guide/output for
     * examples.
     * @values text, json, html, markdown
     */
    outputFormat: {
      type: String,
      default: "html",
      validator(t) {
        return Gn.includes(t);
      }
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Enables the TipTap Link extension and optionally passes configurations to it
     *
     * It is not recommended to use this and the custom link extension at the same time.
     */
    link: {
      type: [Boolean, Object],
      default: !1
    },
    /**
     * Enables the Custom Link extension and optionally passes configurations to it
     *
     * It is not recommended to use this and the built in TipTap link extension at the same time.
     *
     * The custom link does some additional things on top of the built in TipTap link
     * extension such as styling phone numbers and IP adresses as links, and allows you
     * to linkify text without having to type a space after the link. Currently it is missing some
     * functionality such as editing links and will likely require more work to be fully usable,
     * so it is recommended to use the built in TipTap link for now.
     */
    customLink: {
      type: [Boolean, Object],
      default: !1
    },
    /**
     * suggestion object containing the items query function.
     * The valid keys passed into this object can be found here: https://tiptap.dev/api/utilities/suggestion
     *
     * The only required key is the items function which is used to query the contacts for suggestion.
     * items({ query }) => { return [ContactObject]; }
     * ContactObject format:
     * { name: string, avatarSrc: string, id: string }
     *
     * When null, it does not add the plugin.
     */
    mentionSuggestion: {
      type: Object,
      default: null
    },
    /**
     * suggestion object containing the items query function.
     * The valid keys passed into this object can be found here: https://tiptap.dev/api/utilities/suggestion
     *
     * The only required key is the items function which is used to query the channels for suggestion.
     * items({ query }) => { return [ChannelObject]; }
     * ChannelObject format:
     * { name: string, id: string, locked: boolean, channelKey?: string }
     *
     * When null, it does not add the plugin. Setting locked to true will display a lock rather than hash.
     */
    channelSuggestion: {
      type: Object,
      default: null
    },
    /**
     * suggestion object containing the items query function.
     * The valid keys passed into this object can be found here: https://tiptap.dev/api/utilities/suggestion
     *
     * The only required key is the items function which is used to query the slash commands for suggestion.
     * items({ query }) => { return [SlashCommandObject]; }
     * SlashCommandObject format:
     * { command: string, description: string, parametersExample?: string }
     * The "parametersExample" parameter is optional, and describes an example
     * of the parameters that command can take.
     *
     * When null, it does not add the plugin.
     * Note that slash commands only work when they are the first word in the input.
     */
    slashCommandSuggestion: {
      type: Object,
      default: null
    },
    /**
     * Whether the input allows for block quote.
     */
    allowBlockquote: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for bold to be introduced in the text.
     */
    allowBold: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for bullet list to be introduced in the text.
     */
    allowBulletList: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for italic to be introduced in the text.
     */
    allowItalic: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for strike to be introduced in the text.
     */
    allowStrike: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows for underline to be introduced in the text.
     */
    allowUnderline: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows inline code (wrapped in backticks).
     */
    allowCode: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows codeblock to be introduced in the text.
     */
    allowCodeblock: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether the input allows inline images to be rendered.
     */
    allowInlineImages: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input allows color to be introduced in the text.
     */
    allowFontColor: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input allows font size to be introduced in the text.
     */
    allowFontSize: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input allows different font-families to be introduced in the text.
     */
    allowFontFamily: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input allows variables to be introduced in the text.
     */
    allowVariable: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of available variable items that can be inserted.
     */
    variableItems: {
      type: Array,
      default: () => []
    },
    /**
     * Additional TipTap extensions to be added to the editor.
     */
    additionalExtensions: {
      type: Array,
      default: () => []
    },
    /**
     * Manually hide the link bubble menu. The link bubble menu is shown when a link is selected via the cursor.
     * There are some cases when you may want the link to remain selected but hide the bubble menu such as when You
     * are showing a custom link editor popup.
     */
    hideLinkBubbleMenu: {
      type: Boolean,
      default: !1
    },
    /**
     * Show text in HTML div tags instead of paragraph tags
     */
    useDivTags: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow Tables to be used in to the editor
     */
    allowTables: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input allows image resize to be introduced in the text.
     */
    allowImageResize: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    /**
     * Editor input event
     * @event input
     * @type {String|JSON}
     */
    "input",
    /**
     * Input event always in JSON format.
     * @event input
     * @type {JSON}
     */
    "json-input",
    /**
     * Input event always in HTML format.
     * @event input
     * @type {HTML}
     */
    "html-input",
    /**
     * Input event always in text format.
     * @event input
     * @type {String}
     */
    "text-input",
    /**
     * Input event always in markdown format.
     * @event input
     * @type {String}
     */
    "markdown-input",
    /**
     * Event to sync the value with the parent
     * @event update:value
     * @type {String|JSON}
     */
    "update:modelValue",
    /**
     * Editor blur event
     * @event blur
     * @type {FocusEvent}
     */
    "blur",
    /**
     * Editor focus event
     * @event focus
     * @type {FocusEvent}
     */
    "focus",
    /**
     * Enter was pressed. Note that shift enter must be pressed to line break the input.
     * @event enter
     * @type {String}
     */
    "enter",
    /**
     * "Edit link" button was clicked. Fires an event for the consuming component to handle the editing of the link.
     * event contains the link object with two properties href and text.
     * @event edit-link
     * @type {Object}
     */
    "edit-link",
    /**
     * "Selected" event is fired when the user selects text in the editor. returns the currently selected text.
     * If the selected text is partially a link, the full link text is returned.
     * @event selected
     * @type {String}
     */
    "selected",
    /**
     * Event fired when a slash command is selected
     * @event selected-command
     * @type {String}
     */
    "selected-command",
    /**
     * Event fired when a mention is clicked
     * @event mention-click
     * @type {Object}
     */
    "mention-click",
    /**
     * Event fired when the cursor enters a mention. The payload includes the
     * mention data (name, id, avatarSrc, contactKey) plus the native MouseEvent
     * as `event`, which can be used for positioning a hovercard.
     * @event mention-hover
     * @type {Object}
     */
    "mention-hover",
    /**
     * Event fired when the cursor leaves a mention. The payload includes the
     * mention data (name, id, avatarSrc, contactKey) plus the native MouseEvent
     * as `event`.
     * @event mention-leave
     * @type {Object}
     */
    "mention-leave",
    /**
     * Event fired when a channel is clicked
     * @event channel-click
     * @type {Object}
     */
    "channel-click"
  ],
  data() {
    return {
      editor: null,
      appendTo: () => {
        var t;
        return (t = zt(this.$refs.editor.$el).getRootNode()) == null ? void 0 : t.querySelector("body");
      },
      floatingOptions: {
        placement: "top-start"
      },
      i18n: new be(),
      // JSON-to-markdown converter
      jsonToMarkdownConverter: {
        convertToMarkdown(t) {
          return this.processNode(t);
        },
        processNodeContent(t) {
          return t.content ? t.content.map((e) => this.processNode(e)).join("") : "";
        },
        processNode(t) {
          if (!t) return "";
          const o = {
            doc: (n) => this.processDocNode(n),
            paragraph: (n) => this.processParagraphNode(n),
            text: (n) => this.processTextNode(n),
            hardBreak: () => this.processHardBreakNode(),
            blockquote: (n) => this.processBlockquoteNode(n),
            bulletList: (n) => this.processBulletListNode(n),
            orderedList: (n) => this.processOrderedListNode(n),
            listItem: (n) => this.processListItemNode(n),
            codeBlock: (n) => this.processCodeBlockNode(n),
            mention: (n) => this.processMentionNode(n),
            channel: (n) => this.processChannelNode(n),
            "slash-commands": (n) => this.processSlashCommandsNode(n),
            emoji: (n) => this.processEmojiNode(n),
            variable: (n) => this.processVariableNode(n)
          }[t.type];
          return o ? o(t) : this.processUnknownNode(t);
        },
        processDocNode(t) {
          return this.processNodeContent(t);
        },
        processParagraphNode(t) {
          const e = this.processNodeContent(t);
          return e ? e + `
` : `
`;
        },
        processTextNode(t) {
          let e = t.text || "";
          return t.marks && (e = this.applyMarks(e, t.marks)), e;
        },
        processHardBreakNode() {
          return `
`;
        },
        processBlockquoteNode(t) {
          return this.processNodeContent(t).split(`
`).map((o) => o ? `> ${o}` : ">").join(`
`) + `
`;
        },
        processBulletListNode(t) {
          return this.processNodeContent(t);
        },
        processOrderedListNode(t) {
          return t.content ? t.content.map((e, o) => this.processNode(e).replace(/^- /, `${o + 1}. `)).join("") : "";
        },
        processListItemNode(t) {
          const e = this.processNodeContent(t);
          return e ? `- ${e.replace(/\n$/, "")}
` : "";
        },
        processCodeBlockNode(t) {
          return `\`\`\`
${this.processNodeContent(t)}
\`\`\``;
        },
        processMentionNode(t) {
          var i, s, r;
          const e = ((i = t.attrs) == null ? void 0 : i.name) || "", o = ((s = t.attrs) == null ? void 0 : s.id) || "", n = ((r = t.attrs) == null ? void 0 : r.contactKey) || "";
          return `<!-- @mention: {"id": "${o}", "contactKey": "${n}", "name": "${e}"} -->`;
        },
        processChannelNode(t) {
          var s, r, a, l;
          const e = ((s = t.attrs) == null ? void 0 : s.name) || "", o = ((r = t.attrs) == null ? void 0 : r.id) || "", n = ((a = t.attrs) == null ? void 0 : a.locked.toString()) || "", i = ((l = t.attrs) == null ? void 0 : l.channelKey) || "";
          return `<!-- @channel: {"id": "${o}", "channelKey": "${i}", "name": "${e}", "locked": "${n}"} -->`;
        },
        processSlashCommandsNode(t) {
          var n, i;
          const e = ((n = t.attrs) == null ? void 0 : n.command) || "", o = ((i = t.attrs) == null ? void 0 : i.parameters) || "";
          return `/${e}${o ? ` ${o}` : ""}`;
        },
        processEmojiNode(t) {
          var e;
          return ((e = t.attrs) == null ? void 0 : e.code) || "";
        },
        processVariableNode(t) {
          var n, i;
          const e = ((n = t.attrs) == null ? void 0 : n.id) || "", o = ((i = t.attrs) == null ? void 0 : i.altText) || "";
          return `{{${e}=${o}}}`;
        },
        processUnknownNode(t) {
          return this.processNodeContent(t);
        },
        applyMarks(t, e) {
          let o = t;
          return [...e].sort((i, s) => {
            const r = { link: 0, bold: 1, italic: 2, strike: 3, code: 4 };
            return (r[i.type] || 5) - (r[s.type] || 5);
          }).forEach((i) => {
            var s;
            switch (i.type) {
              case "bold":
                o = `**${o}**`;
                break;
              case "italic":
                o = `*${o}*`;
                break;
              case "strike":
                o = `~~${o}~~`;
                break;
              case "code":
                o = `\`${o}\``;
                break;
              case "link": {
                const r = ((s = i.attrs) == null ? void 0 : s.href) || "";
                o = `[${o}](${r})`;
                break;
              }
            }
          }), o;
        }
      }
    };
  },
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        onInput: () => {
        },
        onFocus: () => {
        },
        onBlur: () => {
        }
      };
    },
    // eslint-disable-next-line complexity
    extensions() {
      const t = [gn, Ln, yn, vn];
      t.push(this.useDivTags ? Ui : me), this.allowBold && t.push(xn), this.allowBlockquote && t.push(fn), this.allowBulletList && (t.push(Tn), t.push(_n.extend({
        renderText({ node: n }) {
          return n.textContent;
        }
      })), t.push(kn)), this.allowItalic && t.push(Cn), this.allowStrike && t.push(En), this.allowUnderline && t.push(Sn), this.placeholder && t.push(
        wn.configure({ placeholder: this.placeholder })
      );
      const e = this, o = en.create({
        addKeyboardShortcuts() {
          return {
            "Shift-Enter": ({ editor: n }) => e.allowLineBreaks ? !1 : (n.commands.first(({ commands: i }) => [
              () => i.newlineInCode(),
              () => e.allowBulletList && i.splitListItem("listItem"),
              () => i.createParagraphNear(),
              () => i.liftEmptyBlock(),
              () => i.splitBlock()
            ]), !0),
            Enter: () => e.allowLineBreaks ? !1 : (e.$emit("enter"), !0)
          };
        }
      });
      if (t.push(o), this.link && t.push(On.extend({
        inclusive: !1,
        addKeyboardShortcuts() {
          return {
            "Mod-k": () => (e.$emit("edit-link"), !0)
          };
        }
      }).configure({
        HTMLAttributes: {
          class: "d-link d-wb-break-all"
        },
        openOnClick: !1,
        autolink: !0,
        protocols: Ft
      })), this.customLink && t.push(this.getExtension(Ni, this.customLink)), this.mentionSuggestion) {
        const n = { ...this.mentionSuggestion, ...us };
        t.push(Fi.configure({ suggestion: n }));
      }
      if (this.channelSuggestion) {
        const n = { ...this.channelSuggestion, ...ms };
        t.push(Xi.configure({ suggestion: n }));
      }
      if (this.slashCommandSuggestion) {
        const n = { ...this.slashCommandSuggestion, ...Ts };
        t.push(Qi.configure({
          suggestion: n,
          onSelectedCommand: (i) => {
            this.$emit("selected-command", i);
          }
        }));
      }
      return this.allowVariable && t.push(is.configure({
        variableItems: this.variableItems
      })), t.push(Ii), t.push(In.configure({
        types: ["paragraph"]
      })), this.allowCode && t.push(mn), this.allowCodeblock && t.push(pn.extend({
        renderText({ node: n }) {
          return `\`\`\`
${n.textContent}
\`\`\``;
        }
      }).configure({
        HTMLAttributes: {
          class: "d-rich-text-editor__code-block"
        }
      })), this.allowInlineImages && t.push(Pi.configure({
        resize: {
          enabled: this.allowImageResize,
          alwaysPreserveAspectRatio: !0
        }
      })), (this.allowFontFamily || this.allowFontColor || this.allowFontSize) && t.push(Hn.configure({
        color: this.allowFontColor,
        backgroundColor: !1,
        fontFamily: this.allowFontFamily,
        fontSize: this.allowFontSize,
        lineHeight: !1
      })), this.additionalExtensions.length && t.push(...this.additionalExtensions), this.allowTables && t.push(Dn.configure({ resizable: !0 }), An, Rn, Mn, bn), t;
    },
    inputAttrs() {
      const t = {
        "aria-label": this.inputAriaLabel,
        "aria-multiline": !0,
        role: "textbox"
      };
      return this.editable || (t["aria-readonly"] = !0), t;
    }
  },
  /**
   * Because the Editor instance is initialized when mounted it does not get
   * updated props automatically, so the ones that can change after mount have
   * to be hooked up to the Editor's own API.
   */
  watch: {
    editable(t) {
      this.editor.setEditable(t), this.updateEditorAttributes({ "aria-readonly": !t });
    },
    inputClass(t) {
      this.updateEditorAttributes({ class: t });
    },
    inputAriaLabel(t) {
      this.updateEditorAttributes({ "aria-label": t });
    },
    extensions() {
      this.destroyEditor(), this.createEditor();
    },
    modelValue(t) {
      this.processValue(t);
    }
  },
  created() {
    this.createEditor();
  },
  beforeUnmount() {
    this.destroyEditor();
  },
  mounted() {
    Fn(zt(this.$el), this.$options.name), this.processValue(this.modelValue, !1);
  },
  methods: {
    createEditor() {
      this.editor = new Fe({
        autofocus: this.autoFocus,
        content: this.modelValue,
        editable: this.editable,
        extensions: this.extensions,
        shouldRerenderOnTransaction: !1,
        parseOptions: {
          preserveWhitespace: "full"
        },
        editorProps: {
          attributes: {
            ...this.inputAttrs,
            class: this.inputClass
          },
          handleKeyDown: (t, e) => {
            if (!this.preventTyping) return !1;
            const o = ["Backspace"];
            return !this.allowLineBreaks && !e.shiftKey && o.push("Enter"), !o.includes(e.key);
          },
          handlePaste: (t, e) => {
            const o = e.clipboardData || window.clipboardData, n = o.getData("text/plain"), i = o.getData("text/html");
            return this.processPasteData(t, n, i);
          },
          // Moves the <br /> tags inside the previous closing tag to avoid
          // Prosemirror wrapping them within another </p> tag.
          transformPastedHTML(t) {
            return t.replace(/(<\/\w+>)((<br \/>)+)/g, "$2$3$1");
          }
        }
      }), this.addEditorListeners();
    },
    bubbleMenuShouldShow({ editor: t }) {
      return t.isActive("link");
    },
    /**
     * If the selection contains a link, return the existing link text.
     * Otherwise, use just the selected text.
     * @param editor the editor instance.
     */
    getSelectedLinkText(t) {
      var a, l, u;
      const { view: e, state: o } = t, { from: n, to: i } = e.state.selection, s = o.doc.textBetween(n, i, ""), r = this.editor.state.doc.nodeAt(n);
      return r && ((u = (l = (a = r.marks) == null ? void 0 : a.at(0)) == null ? void 0 : l.type) == null ? void 0 : u.name) === "link" ? r.textContent : s;
    },
    editLink() {
      const t = this.getSelectedLinkText(this.editor), e = {
        href: this.editor.getAttributes("link").href,
        text: t
      };
      this.$emit("edit-link", e);
    },
    removeLink() {
      var t, e, o, n;
      (n = (o = (e = (t = this.editor) == null ? void 0 : t.chain()) == null ? void 0 : e.focus()) == null ? void 0 : o.unsetLink()) == null || n.run();
    },
    openLink() {
      var e, o;
      (o = (e = this.editor) == null ? void 0 : e.chain()) == null || o.focus();
      const t = this.editor.getAttributes("link").href;
      window.open(t, "_blank");
    },
    setLink(t, e, o, n = Ft, i) {
      var a, l, u;
      if (!t) {
        this.removeLink();
        return;
      }
      n.find((d) => d.test(t)) || (t = `${i}${t}`), this.editor.chain().focus().extendMarkRange("link").run();
      const r = (u = (l = (a = this.editor) == null ? void 0 : a.view) == null ? void 0 : l.state) == null ? void 0 : u.selection;
      this.editor.chain().focus().insertContent(e).setTextSelection({ from: r.from, to: r.from + e.length }).setLink({ href: t, class: o.class }).run();
    },
    processValue(t, e = !0) {
      if (!this.editor) return;
      const o = this.getOutput();
      if (!(e && eo(t, o))) {
        if (typeof t == "string" && this.outputFormat === "text") {
          const n = new RegExp(`(${ge})`, "g");
          t = t == null ? void 0 : t.replace(n, '<emoji-component code="$1"></emoji-component>');
        }
        this.editor.commands.setContent(t, { emitUpdate: !1, parseOptions: { preserveWhitespace: "full" } });
      }
    },
    destroyEditor() {
      this.editor.destroy();
    },
    insertPlainTextWithHardBreaks(t, e) {
      const i = (this.pasteRichText ? e : e.replace(/\r\n/g, `
`).replace(/\n\n/g, `
`)).replace(/[\r\n]+$/, "").split(/\r?\n/), s = [];
      for (let r = 0; r < i.length; r++)
        r > 0 && s.push({ type: "hardBreak" }), i[r] && s.push({ type: "text", text: i[r] });
      this.editor.chain().focus().insertContent(s).run();
    },
    shouldPreserveLineBreaks(t, e) {
      return this.pasteRichText ? !e && t && this.hasBlankLines(t) : !!t;
    },
    processPasteData(t, e, o) {
      if (this.shouldPreserveLineBreaks(e, o))
        return this.insertPlainTextWithHardBreaks(t, e), !0;
      if (this.shouldHandlePreformattedHTML(o)) {
        const n = this.extractPreformattedText(o);
        if (n && n.includes(`
`))
          return this.insertPlainTextWithHardBreaks(t, n), !0;
      }
      return !1;
    },
    shouldHandlePreformattedHTML(t) {
      return this.pasteRichText && t && this.containsPreformattedContent(t);
    },
    containsPreformattedContent(t) {
      const e = document.createElement("div");
      e.innerHTML = t;
      const o = e.querySelectorAll("*");
      for (const n of o)
        if (this.hasPreWhitespace(n) && this.hasLineBreaks(n))
          return !0;
      return !1;
    },
    hasPreWhitespace(t) {
      const e = t.getAttribute("style") || "", o = t.style.whiteSpace || "", n = o === "pre" || o === "pre-wrap", i = e.includes("white-space: pre");
      return n || i;
    },
    hasLineBreaks(t) {
      return t.textContent && t.textContent.includes(`
`);
    },
    hasBlankLines(t) {
      return t.includes(`

`) || /\n\s*\n/.test(t);
    },
    extractPreformattedText(t) {
      const e = document.createElement("div");
      return e.innerHTML = t, this.walkAndExtractText(e);
    },
    walkAndExtractText(t) {
      let e = "";
      if (t.nodeType === Node.TEXT_NODE)
        e += t.textContent;
      else if (t.nodeType === Node.ELEMENT_NODE)
        if (this.hasPreWhitespace(t))
          e += t.textContent;
        else
          for (const o of t.childNodes)
            e += this.walkAndExtractText(o);
      return e;
    },
    triggerInputChangeEvents() {
      const t = this.getOutput();
      this.$emit("input", t), this.$emit("update:modelValue", t);
      const e = this.editor.getJSON();
      this.$emit("json-input", e);
      const o = this.editor.getHTML();
      this.$emit("html-input", o);
      const n = this.editor.getText({ blockSeparator: `
` });
      this.$emit("text-input", n);
      const i = this.jsonToMarkdownConverter.convertToMarkdown(e);
      this.$emit("markdown-input", i);
    },
    /**
     * The Editor exposes event hooks that we have to map our emits into. See
     * https://tiptap.dev/api/events for all events.
     */
    addEditorListeners() {
      this.editor.on("create", () => {
        this.triggerInputChangeEvents();
      }), this.editor.on("update", () => {
        this.triggerInputChangeEvents();
      }), this.editor.on("selectionUpdate", ({ editor: t }) => {
        this.$emit("selected", this.getSelectedLinkText(t));
      }), this.editor.on("focus", ({ event: t }) => {
        this.$emit("focus", t);
      }), this.editor.on("blur", ({ event: t }) => {
        this.$emit("blur", t);
      }), this.editor.on("mention-click", (t) => {
        this.$emit("mention-click", t);
      }), this.editor.on("mention-hover", (t) => {
        this.$emit("mention-hover", t);
      }), this.editor.on("mention-leave", (t) => {
        this.$emit("mention-leave", t);
      }), this.editor.on("channel-click", (t) => {
        this.$emit("channel-click", t);
      });
    },
    getOutput() {
      switch (this.outputFormat) {
        case "json":
          return this.editor.getJSON();
        case "html":
          return this.editor.getHTML();
        case "markdown":
          return this.jsonToMarkdownConverter.convertToMarkdown(this.editor.getJSON());
        case "text":
        default:
          return this.editor.getText({ blockSeparator: `
` });
      }
    },
    getExtension(t, e) {
      var o;
      return typeof e == "boolean" ? t : (o = t.configure) == null ? void 0 : o.call(t, e);
    },
    updateEditorAttributes(t) {
      this.editor.setOptions({
        editorProps: {
          attributes: {
            ...this.inputAttrs,
            class: this.inputClass,
            ...t
          }
        }
      });
    },
    focusEditor() {
      this.editor.commands.focus();
    }
  }
}, ks = { class: "d-popover__dialog" };
function Cs(t, e, o, n, i, s) {
  const r = T("dt-button"), a = T("dt-stack"), l = T("bubble-menu"), u = T("editor-content");
  return k(), et("div", null, [
    i.editor && o.link && !o.hideLinkBubbleMenu ? (k(), M(l, {
      key: 0,
      editor: i.editor,
      "should-show": s.bubbleMenuShouldShow,
      options: i.floatingOptions,
      "append-to": i.appendTo,
      style: { visibility: "visible" }
    }, {
      default: C(() => [
        nt("div", ks, [
          I(a, {
            direction: "row",
            class: "d-rich-text-editor-bubble-menu__button-stack",
            gap: "0"
          }, {
            default: C(() => [
              I(r, {
                kind: "muted",
                importance: "clear",
                onClick: s.editLink
              }, {
                default: C(() => [
                  at($(i.i18n.$t("DIALTONE_RICH_TEXT_EDITOR_EDIT_BUTTON_LABEL")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              I(r, {
                kind: "muted",
                importance: "clear",
                onClick: s.openLink
              }, {
                default: C(() => [
                  at($(i.i18n.$t("DIALTONE_RICH_TEXT_EDITOR_OPEN_LINK_BUTTON_LABEL")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              I(r, {
                kind: "danger",
                importance: "clear",
                onClick: s.removeLink
              }, {
                default: C(() => [
                  at($(i.i18n.$t("DIALTONE_RICH_TEXT_EDITOR_REMOVE_BUTTON_LABEL")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["editor", "should-show", "options", "append-to"])) : it("", !0),
    I(u, pe({
      ref: "editor",
      editor: i.editor,
      class: "d-rich-text-editor",
      "data-qa": "dt-rich-text-editor"
    }, s.attrs), null, 16, ["editor"])
  ]);
}
const gr = /* @__PURE__ */ q(_s, [["render", Cs]]);
export {
  gr as default
};
//# sourceMappingURL=rich-text-editor.js.map
